import { render, staticRenderFns } from "./stoppedMachine.vue?vue&type=template&id=71cdba17"
import script from "./stoppedMachine.vue?vue&type=script&lang=js"
export * from "./stoppedMachine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports